{
    "Profile_SideBar.policies": "Policies",
    "Profile_SideBar.summary": "Summary",
    "Profile_SideBar.renewal": "Renewal",
    "Profile_SideBar.terms": "Terms",
    "Profile_SideBar.underwriterCoverageAdjustment": "Underwriting",
    "Profile_SideBar.liabilityExposure": "Liability Exposure",
    "Profile_SideBar.policy": "Policy",
    "Profile_SideBar.applicant": "Insured",
    "Profile_SideBar.insuranceApplicant": "Insurance Applicant",
    "Profile_SideBar.sn-commercial.business": "Business Info",
    "Profile_SideBar.sn-commercial.insuranceHistory": "Insurance History",
    "Profile_SideBar.sn-commercial.coverages": "Coverages",
    "Profile_SideBar.sn-commercial.additionalInsureds": "Additional Insureds",
    "Profile_SideBar.sn-commercial.lossPayees": "Loss Payees",
    "Profile_SideBar.sn-commercial.employment": "Employment",
    "Profile_SideBar.sn-commercial.memberships": "Memberships",
    "Profile_SideBar.sn-small-business-insurance.business": "Business Info",
    "Profile_SideBar.sn-small-business-insurance.insuranceHistory": "Insurance History",
    "Profile_SideBar.sn-small-business-insurance.coverages": "Coverages",
    "Profile_SideBar.sn-small-business-insurance.additionalInsureds": "Additional Insureds",
    "Profile_SideBar.sn-small-business-insurance.lossPayees": "Loss Payees",
    "Profile_SideBar.securemyoffer.secureMyOffer": "Secure My Offer",
    "Profile_SideBar.securemyoffer.insuranceApplicant": "Insurance Applicant",
    "Profile_SideBar.auto.drivers": "Drivers",
    "Profile_SideBar.auto.vehicles": "Vehicles",
    "Profile_SideBar.usauto.drivers": "Drivers",
    "Profile_SideBar.usauto.vehicles": "Vehicles",
    "Profile_SideBar.home.residents": "Residents",
    "Profile_SideBar.home.dwellings": "Dwellings",
    "Profile_SideBar.ushome.residents": "Residents",
    "Profile_SideBar.ushome.dwellings": "Dwellings",
    "Profile_SideBar.payment": "Payment",
    "Profile_SideBar.documents": "Documents",
    "Profile_SideBar.notes": "Notes",
    "Profile_SideBar.history": "History",
    "Profile_SideBar.logs": "API Logs",
    "Profile_SideBar.securemyoffer.additionalSellers": "Additional Sellers"
}
